const Colors = {
    // primary:'#541554',
    primary:'#3F3D56',
    secondary:"#7FFFD4",
    // secondary:"#611f69",
    bglight:"#aef8df",
    // secondary:"#00DEDE",
    darkpurple:'#611f69',
    bgcolor:'#f4ede4',
    btncolor:'#4285f4',
    white:"#FFFFFF",
    gray:'gray',
    darkblue:'#32325d',
    blue:'#4285f4',
    yellow:"#ffbe55",
    bgdarkyllw:"#202701",


}
export default Colors